import { useMemo } from 'react'
import type { AccommodationMonthView } from './AccommodationCalendarMonthPicker'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import { min, nonNullable, sortBy } from 'lib/array/arrayUtils'
import AccommodationCalendarMonthCell from './AccommodationCalendarMonthCell'

const MonthGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${rem(8)};

  ${mediaQueryUp.tablet} {
    grid-template-columns: repeat(4, 1fr);
  }
`

interface Props {
  monthViews: Array<AccommodationMonthView>
  onSelect?: (view: AccommodationMonthView) => void
  priceType?: 'default' | 'member'
}

function AccommodationCalendarMonthGrid(props: Props) {
  const { monthViews, onSelect, priceType } = props

  const sortedMonths = useMemo(() => {
    return sortBy(monthViews, view => new Date(view.year, view.month), 'asc')
  }, [monthViews])

  // We change the colour of price for the cheapest month in the year
  const cheapestPrice = useMemo(() => {
    const prices = nonNullable(monthViews.map(view => view.pricing?.price))
    return min(prices)
  }, [monthViews])

  return <MonthGrid>
    {sortedMonths.map(month => <AccommodationCalendarMonthCell
      key={month.month}
      view={month}
      onSelect={onSelect}
      cheapest={!!cheapestPrice && cheapestPrice === month.pricing?.price}
      priceType={priceType}
    />)}
  </MonthGrid>
}

export default AccommodationCalendarMonthGrid
